import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { QueryKeys } from './_query_keys'
import { HttpRequest } from '../services/_http'

export type VideoPlayerErrorQueryParams = Record<string, unknown> | undefined

export const useVideoPlayerErrorLog = (
  searchOptions?: VideoPlayerErrorQueryParams,
  options?: UseQueryOptions
): UseQueryResult<any> => {
  const method = 'GET'
  const queryKey = [QueryKeys.VIDEO_PLAYER_ERROR_LOGS, searchOptions]

  return useQuery({
    queryKey,
    queryFn: () =>
      HttpRequest({
        url: `${APIEndpoints.VideoPlayerError}`,
        params: searchOptions,
        method,
      }),
    refetchOnWindowFocus: false,
    cacheTime: 0,
    ...options,
  })
}
